import React, { useEffect, useRef, useState } from 'react';
import { getPathForSurvey, useOutsideClick } from '../../../utils/helper';
import { Link, useNavigate } from 'react-router-dom';
import Dots from '../../../assets/images/Dots.svg';
import ActiveDots from '../../../assets/images/active-dots.svg';
import gallery from '../../../assets/images/gallery.png';
import LazyLoadImageProp from '../../../component/common/LazyLoadImage';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const SurveyCrad = ({
  item,
  handleQuestionAction,
  Id,
  setId,
  handleDeletePulseSurve,
  isAdmin = true,
  handleDeactivatePulseSurvey,
  handleCopyPulseSurvey
}) => {
  const sureyRef = useRef(null);
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [imageError, setImageError] = useState(true);
  const cardData = pulseSurveyPageData.surveyCardData;

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsedData = JSON.parse(userData);
      setUserType(parsedData.userType);
    }
  }, []);

  useOutsideClick(sureyRef, () => {
    if (Id === item?.id) setId('');
  });

  const checkImageAccess = async (url) => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      if (response.ok) {
        setImageError(false);
      } else {
        setImageError(true);
      }
    } catch (error) {
      setImageError(true);
    }
  };

  useEffect(() => {
    if (item.logo) {
      checkImageAccess(item.logo);
    }
  }, [item?.logo]);

  return (
    <div className="w-full bg-white dark:bg-shoorah-darkBgColor dark:border-none border-[1.5px] border-shoorah-borderGray rounded-2xl">
      <div className="relative bg-[#F4F4F4] dark:bg-shoorah-gray6 rounded-t-2xl overflow-hidden">
        {/* {item.logo && !imageError ? ( */}
        {item.logo ? (
          // <LazyLoadImageProp
          //   imageSrc={item.logo}
          //   className="object-cover w-full h-[160px]"
          //   />
          <img src={item.logo} alt="survey" className="object-cover w-full h-[160px]" />
        ) : (
          <div className="flex justify-center items-center h-[160px]">
            <img src={gallery} alt="survey placeholder" className="w-[48px] h-[48px]" />
          </div>
        )}
      </div>

      <div className="h-fit flex flex-col lg:gap-4 gap-2 lg:px-4 px-3 lg:py-6 py-4">
        <div className="flex justify-between items-center">
          <p className="lg:text-[20px] text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-bold leading-6 truncate max-w-[80%]">
            {item?.title}
          </p>
          <button
            ref={sureyRef}
            className="relative"
            onClick={() => handleQuestionAction(item?.id)}
          >
            <img src={Dots} alt="Dots icon" className="w-6 h-6 block dark:hidden" />
            <img src={ActiveDots} alt="Dots icon" className="w-6 h-6 hidden dark:block" />
            {item?.id === Id && isAdmin && (
              <div className="w-40 z-50 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none absolute top-4 right-0 mt-2 border-[1.5px] border-shoorah-gray1 rounded-lg shadow-lg py-[14px]">
                {/* <Link
                  className="py-2 px-5 hover:bg-shoorah-borderGray dark:hover:bg-shoorah-darkBgColor cursor-pointer font-medium leading-6 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg text-left w-full block"
                  to={getPathForSurvey(
                    `/pulse-survey/add-edit-survey?id=${item.id}&type=${item.type}&page=view`
                  )}
                >
                  Open
                </Link> */}

                <Link
                  to={getPathForSurvey(
                    `/pulse-survey/add-edit-survey?id=${item.id}&type=${item.type}&page=edit`
                  )}
                  className="py-2 px-5 hover:bg-shoorah-borderGray dark:hover:bg-shoorah-darkBgColor cursor-pointer font-medium leading-6 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg text-left w-full block"
                >
                  {cardData.editBtnText}
                </Link>

                <div className="border-b border-gray-400 w-full"></div>

                {item.status === 5 && (
                  <Link
                    to={getPathForSurvey(
                      `/pulse-survey/add-edit-survey?id=${item.id}&type=${item.type}&page=results`
                    )}
                    className="py-2 px-5 hover:bg-shoorah-borderGray dark:hover:bg-shoorah-darkBgColor cursor-pointer font-medium leading-6 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg text-left w-full block"
                  >
                    {cardData.resultsBtnText}
                  </Link>
                )}
                {/* 
                {item?.type === 1 && (
                  <div
                    className="py-2 px-5 hover:bg-shoorah-borderGray dark:hover:bg-shoorah-darkBgColor cursor-pointer font-medium leading-6 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg text-left"
                    onClick={() => handleCopyPulseSurvey(item.id)}
                  >
                    Duplicate
                  </div>
                )} */}

                <div className="border-b border-gray-400 w-full"></div>

                {(userType === 0 || userType === 3) && (
                  <div
                    className="py-2 px-5 hover:bg-shoorah-borderGray dark:hover:bg-shoorah-darkBgColor cursor-pointer text-red-700 font-medium leading-6 text-[16px] text-left"
                    onClick={() => handleDeletePulseSurve(item.id)}
                  >
                    {cardData.deleteBtnText}
                  </div>
                )}

                {item.status === 5 && (
                  <div
                    className="py-2 px-5 hover:bg-shoorah-borderGray dark:hover:bg-shoorah-darkBgColor cursor-pointer text-red-700 font-medium leading-6 text-[16px] text-left"
                    onClick={() => handleDeactivatePulseSurvey(item.id)}
                  >
                    {cardData.deActivateBtnText}
                  </div>
                )}
              </div>
            )}

            {item.id === Id && !isAdmin && (
              <div className="w-auto z-50 bg-white absolute top-8 right-0 border-[1.5px] border-[#DDDDDD] rounded-lg shadow-lg">
                <button
                  onClick={() => {
                    navigate(
                      getPathForSurvey(`/pulse-survey/add-edit-survey?templateId=${item.id}`)
                    );
                    localStorage.setItem('surveyType', 'Survey');
                  }}
                >
                  <div className="text-left py-2 px-5  hover:bg-shoorah-borderGray cursor-pointer font-medium whitespace-nowrap leading-6 text-[16px]">
                    {cardData.sharedAsSurveyBtnText}
                  </div>
                </button>
              </div>
            )}
          </button>
        </div>
        <p className="lg:text-[16px] text-[14px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-normal leading-5 truncate">
          {item.type === 1 ? `${cardData.usedByTextBeforeCount} ${item?.usedCount}` : `${item?.usedCount}${cardData.responseTextAfterCount}`}
        </p>
      </div>
    </div>
  );
};

export default SurveyCrad;
